import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _mapOrderBy2SortType, _mapSource2SourceType;
import { camelKeys } from '@tencent/ark-utils/lib/object';
import { isAuthenticationFailureCode } from '@tencent/docs-login';
import { DocType, getDocTypeFromMimeType, isAddon, isOnlineDoc } from '@tencent/docs-mime-types';
import { camelCaseKeys } from '@tencent/docs-scenario-component-tools';
import axios from 'axios';
import * as qs from 'querystringify';
import { getXsrfToken } from "../cgi/cookies";
import { DOC_LIST_URL, OrderType, SortType, SourceType } from "../cgi/doc-list";
import { mapSpecialFolderId2ListType } from "../common/compat";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { OrderBy, SpecialFolderId, SpecialSource, VAGUE_ROOT_ID } from "../common/list-query";
import { requestV1Cgi, RetCode } from "../data-source/network-request";
import { COLLABORATION_SPACE_KIND } from "../model/collaboration-space";
import { DEFAULT_CREATOR_DOMAIN, DEFAULT_DOMAIN_ID, DocPolicy, DocSource, DocStatus, DRIVE_FILE_KIND, DriveFileType } from "../model/drive-file";
import { DRIVE_FOLDER_KIND, FOLDER_ATTRIBUTE, ListType } from "../model/drive-folder";
import { TencentDocMimeType } from "../model/file-node";
import { SHORT_CUT_KIND } from "../model/shortcut";
export var DocListRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(DocListRequest, _DriveRequest);
  var _super = _createSuper(DocListRequest);
  function DocListRequest(params) {
    var _this;
    _classCallCheck(this, DocListRequest);
    _this = _super.call(this, params);
    _defineProperty(_assertThisInitialized(_this), "data", void 0);
    _this.params = params;
    _this.payload = null;
    _this.response = null;
    return _this;
  }
  _createClass(DocListRequest, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
        var prefetchDocListInfo, _yield$prefetchDocLis, status, response, retcode;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.payload = this.getPayload();
              prefetchDocListInfo = this.getPrefetchDocList(); // 目前仅在列表页首屏预拉取时，会使用该数据
              if (!prefetchDocListInfo) {
                _context.next = 16;
                break;
              }
              _context.next = 5;
              return prefetchDocListInfo.data;
            case 5:
              _yield$prefetchDocLis = _context.sent;
              status = _yield$prefetchDocLis.status;
              response = _yield$prefetchDocLis.response;
              if (!(status !== 200)) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", requestV1Cgi(payload));
            case 10:
              retcode = response === null || response === void 0 ? void 0 : response.retcode; // FIXME: 耦合了 desktop/src/core/user/user-service.ts 对 retcode 的处理机制。
              // 1、因为 desktop 监听通过 axios 发起的请求并对其中特殊 retcode 做了处理。
              // 2、又因为预拉取 doclist 不是使用 axios，所以需要 mock 一次假的 axios 请求。
              if (!(retcode && ([RetCode.IndependentPasswordRequired, RetCode.XSRF].includes(retcode) || isAuthenticationFailureCode(retcode)))) {
                _context.next = 14;
                break;
              }
              _context.next = 14;
              return this.mockAxiosAuthenticationError(retcode);
            case 14:
              console.log('usePrefetchDocList, retcode:', retcode);
              return _context.abrupt("return", response);
            case 16:
              return _context.abrupt("return", requestV1Cgi(payload));
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function request(_x) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "getPayload",
    value: function getPayload() {
      var _this2 = this;
      if (this.params.folderId === VAGUE_ROOT_ID) {
        throw new DriveApiError({
          name: "DocListParamsError",
          message: "\"".concat(VAGUE_ROOT_ID, "\" can not specify a special folder precisely. Please use [SpecialFolderId]."),
          params: this.params,
          payload: this.payload,
          response: this.response,
          context: {
            errorFolderId: VAGUE_ROOT_ID
          }
        });
      }
      var folderId = Object.values(SpecialFolderId).some(function (specialFolderId) {
        return _this2.params.folderId === specialFolderId;
      }) ? VAGUE_ROOT_ID : this.params.folderId;
      var listType = this.getListType();
      var limit = this.params.limit;
      var offset = this.params.offset;
      var docTypes = this.getDocTypes();
      var _this$getOrder = this.getOrder(),
        orderType = _this$getOrder.orderType,
        sortType = _this$getOrder.sortType;
      var sourceType = this.getSourceType();
      this.data = {
        folder_id: folderId,
        limit: limit,
        list_type: listType,
        order_type: orderType,
        doc_type: docTypes,
        source_type: sourceType,
        sort_type: sortType,
        start: offset,
        xsrf: getXsrfToken()
      };
      if (this.data.doc_type !== undefined && this.data.doc_type !== DocType.Unknown.toString()) {
        Object.assign(this.data, {
          type_filter: true
        });
      }
      if (this.data.source_type !== undefined && this.data.source_type !== SourceType.All) {
        Object.assign(this.data, {
          owner_filter: true,
          is_owner: this.data.source_type
        });
      }
      return {
        method: 'post',
        url: DOC_LIST_URL,
        data: qs.stringify(this.data)
      };
    }
  }, {
    key: "getResult",
    value: function getResult() {
      var _this$response,
        _this3 = this,
        _this$response2;
      if (!this.response) {
        throw new DriveApiError({
          name: "DocListResultError",
          message: 'No response returned. Please capture the network packet to check the error.',
          params: this.params,
          payload: this.payload,
          response: this.response
        });
      }
      if (this.response.retcode) {
        throw new DriveApiError({
          name: "DocListResultError",
          message: this.response.msg,
          params: this.params,
          payload: this.payload,
          response: this.response
        });
      }
      var isShared = this.getListType() === ListType.Shared;
      var sharedFolderIdMap = {};
      return {
        items: (_this$response = this.response) === null || _this$response === void 0 ? void 0 : _this$response.list_info.reduce(function (prev, curr) {
          if (isShared && curr.pad_id && curr.link_file_id && !curr.is_shortcut && curr.pad_id !== curr.link_file_id) {
            sharedFolderIdMap[curr.link_file_id] = curr.pad_id;
            curr.pad_id = curr.link_file_id;
          }
          var fileNode = _this3.getFileNodeByListInfoItem(curr);
          prev.push(fileNode);
          return prev;
        }, []),
        hasNext: this.response.next !== 0,
        currentFolderAttribute: camelKeys(this.response.attribute),
        currentPath: (_this$response2 = this.response) === null || _this$response2 === void 0 ? void 0 : _this$response2.parents.map(function (parent) {
          return _this3.getFileNodeByListInfoItem(parent);
        }),
        sharedFolderIdMap: sharedFolderIdMap
      };
    }

    // eslint-disable-next-line max-lines-per-function
  }, {
    key: "getFileNodeByListInfoItem",
    value: function getFileNodeByListInfoItem(listInfoItem) {
      var _listInfoItem$doc_typ;
      // vip 信息
      var ownerVipInfo = JSON.parse(listInfoItem.owner_vip_info || 'null');

      // 显示后缀名
      var isExtVisible = !!listInfoItem.ext && !isOnlineDoc(listInfoItem.mime_type) && !isAddon(listInfoItem.mime_type);
      var displayName = isExtVisible ? "".concat(listInfoItem.title, ".").concat(listInfoItem.ext) : listInfoItem.title;
      var fileNode = {
        kind: '',
        id: listInfoItem.folder_id || listInfoItem.pad_id,
        title: listInfoItem.title,
        collaborationFlag: listInfoItem.collaboration_flag,
        createTs: listInfoItem.create_ts,
        creator: {
          uid: listInfoItem.creator_uid,
          nick: listInfoItem.creator_nick
        },
        docType: (_listInfoItem$doc_typ = listInfoItem.doc_type) !== null && _listInfoItem$doc_typ !== void 0 ? _listInfoItem$doc_typ : DocType.Unknown,
        iconUrl: listInfoItem.doc_icon || listInfoItem.icon_url,
        lastBrowseTs: listInfoItem.last_browse_ts,
        lastDeleteTs: listInfoItem.last_delete_ts,
        lastModifyTs: listInfoItem.last_modify_ts,
        lastModifier: {
          uid: listInfoItem.last_modify_uid,
          nick: listInfoItem.last_modify_nick
        },
        mimeType: listInfoItem.mime_type,
        owner: {
          uid: listInfoItem.owner_uid,
          nick: listInfoItem.owner_nick,
          avatarFrameUrl: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.avatar_frame_url,
          badgeUrl: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.badge_url,
          expiredStatus: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.expired_status,
          vipLevel: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.vip_level,
          renewalStatus: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.renewal_status
        },
        originParentId: listInfoItem.origin_folder_id || null,
        // 空字符串 fallback 到 null
        parentId: listInfoItem.parent_folder_id,
        thirdAppId: listInfoItem.third_appid || null,
        // 空字符串 fallback 到 null
        isOwnedByMe: !!listInfoItem.is_owner,
        displayName: displayName
      };
      switch (true) {
        case this.shouldBeShortcut(listInfoItem):
          {
            var _listInfoItem$doc_url;
            Object.assign(fileNode, {
              kind: SHORT_CUT_KIND,
              targetId: listInfoItem.link_file_id,
              url: (_listInfoItem$doc_url = listInfoItem.doc_url) !== null && _listInfoItem$doc_url !== void 0 ? _listInfoItem$doc_url : '',
              personalizeInfo: listInfoItem.personalize_info ? {
                background: listInfoItem.personalize_info.background,
                isExpire: listInfoItem.personalize_info.is_expire,
                titleColor: listInfoItem.personalize_info.title_color,
                mode: listInfoItem.personalize_info.mode
              } : null
            });
            break;
          }
        case this.shouldBeDriveFile(listInfoItem):
          {
            var _listInfoItem$group_n, _listInfoItem$last_co, _listInfoItem$last_pi, _listInfoItem$doc_pol, _listInfoItem$doc_sou, _listInfoItem$doc_sta, _listInfoItem$doc_thu, _listInfoItem$doc_url2;
            Object.assign(fileNode, {
              kind: DRIVE_FILE_KIND,
              ext: listInfoItem.ext,
              clientId: listInfoItem.client_id || null,
              // 空字符串 fallback 到 null
              creatorDomainId: listInfoItem.creator_domain || DEFAULT_CREATOR_DOMAIN,
              domainId: listInfoItem.domain_id || DEFAULT_DOMAIN_ID,
              driveFileType: DriveFileType.CLOUD,
              groupChatKey: listInfoItem.group_chat_key || null,
              // 空字符串 fallback 到 null
              groupName: (_listInfoItem$group_n = listInfoItem.group_name) !== null && _listInfoItem$group_n !== void 0 ? _listInfoItem$group_n : null,
              isCollected: !!listInfoItem.is_collected,
              isPinned: !!listInfoItem.is_pinned,
              lastCollectTs: (_listInfoItem$last_co = listInfoItem.last_collect_ts) !== null && _listInfoItem$last_co !== void 0 ? _listInfoItem$last_co : 0,
              lastPinnedTs: (_listInfoItem$last_pi = listInfoItem.last_pinned_ts) !== null && _listInfoItem$last_pi !== void 0 ? _listInfoItem$last_pi : 0,
              officialAuthInfo: listInfoItem.official_auth_info,
              personalizeInfo: listInfoItem.personalize_info ? {
                background: listInfoItem.personalize_info.background,
                isExpire: listInfoItem.personalize_info.is_expire,
                titleColor: listInfoItem.personalize_info.title_color,
                mode: listInfoItem.personalize_info.mode
              } : null,
              policy: (_listInfoItem$doc_pol = listInfoItem.doc_policy) !== null && _listInfoItem$doc_pol !== void 0 ? _listInfoItem$doc_pol : DocPolicy.Private,
              source: (_listInfoItem$doc_sou = listInfoItem.doc_source) !== null && _listInfoItem$doc_sou !== void 0 ? _listInfoItem$doc_sou : DocSource.Personal,
              status: (_listInfoItem$doc_sta = listInfoItem.doc_status) !== null && _listInfoItem$doc_sta !== void 0 ? _listInfoItem$doc_sta : DocStatus.Normal,
              tenantId: listInfoItem.tenant_id || null,
              // 空字符串 fallback 到 null
              thumbnailUrl: (_listInfoItem$doc_thu = listInfoItem.doc_thumbnail) !== null && _listInfoItem$doc_thu !== void 0 ? _listInfoItem$doc_thu : '',
              url: (_listInfoItem$doc_url2 = listInfoItem.doc_url) !== null && _listInfoItem$doc_url2 !== void 0 ? _listInfoItem$doc_url2 : '',
              weDriveInfo: listInfoItem.wedrive_info ? {
                docId: listInfoItem.wedrive_info.doc_id,
                docUrl: listInfoItem.wedrive_info.doc_url,
                fileId: listInfoItem.wedrive_info.file_id
              } : null,
              cosInfo: camelCaseKeys(listInfoItem.cos_info),
              size: typeof listInfoItem.size === 'string' ? Number(listInfoItem.size) : null
            });
            break;
          }
        case this.shouldBeCollaborationSpace(listInfoItem):
          {
            Object.assign(fileNode, {
              kind: COLLABORATION_SPACE_KIND,
              attribute: null,
              roleId: listInfoItem.role_id
            });
            break;
          }
        case this.shouldBeDriveFolder(listInfoItem):
          {
            Object.assign(fileNode, {
              kind: DRIVE_FOLDER_KIND,
              // 目前只能搜到自己的数据，因此文件夹都有权限
              attribute: FOLDER_ATTRIBUTE
            });
            break;
          }
        default:
          {
            throw new DriveApiError({
              name: "DocListResultError",
              message: 'Unknown kind of [FileNode]. Catch this error and check the data structure of this [FileNode] in error context.',
              params: this.params,
              payload: this.payload,
              response: this.response,
              context: {
                fileNode: fileNode
              }
            });
          }
      }
      return fileNode;
    }
  }, {
    key: "getOrder",
    value: function getOrder() {
      var order = this.params.orders[0];
      if (!order) {
        throw new DriveApiError({
          name: "DocListParamsError",
          message: 'Please make sure that at least one order has been set in params.',
          params: this.params,
          payload: this.payload,
          response: this.response,
          context: {
            orders: this.params.orders
          }
        });
      }
      var orderType = order.asc ? OrderType.Asc : OrderType.Desc;
      var orderBy = order.by;
      var sortType = mapOrderBy2SortType[orderBy];
      if (!sortType) {
        throw new DriveApiError({
          name: "DocListParamsError",
          message: "This api does not support this type of [OrderBy]: ".concat(orderBy, "."),
          params: this.params,
          payload: this.payload,
          response: this.response,
          context: {
            orderBy: orderBy,
            mapOrderBy2SortType: mapOrderBy2SortType
          }
        });
      }
      return {
        orderType: orderType,
        sortType: sortType
      };
    }
  }, {
    key: "getDocTypes",
    value: function getDocTypes() {
      var _this4 = this;
      var mimeTypes = this.params.mimeTypes;
      // 未传或传空时，表示不对 mimeType 进行筛选
      if (!(mimeTypes !== null && mimeTypes !== void 0 && mimeTypes.length)) return DocType.Unknown.toString();

      // 协作空间会 fallback 到普通文件夹
      if (mimeTypes.includes(TencentDocMimeType.TencentCollaborationSpace)) {
        console.warn('Please note that because there is no [DocType.CollaborationSpace], ' + "mimeType ".concat(TencentDocMimeType.TencentCollaborationSpace, " is mapped to [DocType.Folder]."));
      }
      var docTypes = mimeTypes.map(function (mimeType) {
        var result = getDocTypeFromMimeType(mimeType);
        if (typeof result === 'undefined') {
          throw new DriveApiError({
            name: "DocListParamsError",
            message: "MimeType ".concat(mimeType, " has no corresponding [DocType]."),
            params: _this4.params,
            payload: _this4.payload,
            response: _this4.response,
            context: {
              mimeType: mimeType,
              getDocTypeFromMimeType: getDocTypeFromMimeType
            }
          });
        }
        return result.toString();
      }).join(','); // 多个 mimeType 用逗号连接

      return docTypes;
    }
  }, {
    key: "getListType",
    value: function getListType() {
      // 当 folderId 不是 SpecialFolderId 时，认为它为【我的文档】下的某个 folderId
      return mapSpecialFolderId2ListType[this.params.folderId] || ListType.MyDoc;
    }
  }, {
    key: "getSourceType",
    value: function getSourceType() {
      var source = this.params.source;
      if (!source) return SourceType.All;
      if (Array.isArray(source)) {
        throw new DriveApiError({
          name: "DocListParamsError",
          message: 'This api does not support to query source by uid. Please use [SpecialSource].',
          params: this.params,
          payload: this.payload,
          response: this.response,
          context: {
            source: source
          }
        });
      }
      return mapSource2SourceType[source];
    }
  }, {
    key: "shouldBeShortcut",
    value: function shouldBeShortcut(listInfoItem) {
      return !!listInfoItem.is_shortcut;
    }
  }, {
    key: "shouldBeDriveFile",
    value: function shouldBeDriveFile(listInfoItem) {
      return !!listInfoItem.pad_id;
    }
  }, {
    key: "shouldBeDriveFolder",
    value: function shouldBeDriveFolder(listInfoItem) {
      return !!listInfoItem.folder_id && !listInfoItem.collaboration_flag;
    }
  }, {
    key: "shouldBeCollaborationSpace",
    value: function shouldBeCollaborationSpace(listInfoItem) {
      return !!listInfoItem.folder_id && !!listInfoItem.collaboration_flag;
    }

    // 拿取预拉取的数据时，校验校验是否可使用，不可使用则为 undefined；可使用时，也仅可使用一次
  }, {
    key: "getPrefetchDocList",
    value: function getPrefetchDocList() {
      var _this5 = this,
        _prefetchDocListMap;
      var listType = this.getListType();
      var folderId = Object.values(SpecialFolderId).some(function (specialFolderId) {
        return _this5.params.folderId === specialFolderId;
      }) ? VAGUE_ROOT_ID : this.params.folderId;
      var docListKey = "".concat(folderId, "-").concat(listType);
      var prefetchDocListInfo = (_prefetchDocListMap = window.prefetchDocListMap) === null || _prefetchDocListMap === void 0 ? void 0 : _prefetchDocListMap.get(docListKey);
      // 预拉取结果已被使用时，返回 undefined。（请求参数（this.data）理论逻辑上不会为空）
      if (!this.data || !prefetchDocListInfo || prefetchDocListInfo.used) return undefined;

      // 校验请求的参数是否一致
      var valid = Object.entries(this.data).every(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return prefetchDocListInfo.payload[key] === value;
      });
      if (!valid) return undefined;
      prefetchDocListInfo.used = true; // 读取成功后，设为已读，不可再使用

      return prefetchDocListInfo;
    }
  }, {
    key: "mockAxiosAuthenticationError",
    value: function () {
      var _mockAxiosAuthenticationError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(retcode) {
        var adapter;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              adapter = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(config) {
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", new Promise(function (resolve) {
                          resolve({
                            data: {
                              retcode: retcode
                            },
                            status: 200,
                            statusText: 'success',
                            headers: {},
                            config: config
                          });
                        }));
                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function adapter(_x3) {
                  return _ref3.apply(this, arguments);
                };
              }();
              _context3.next = 3;
              return axios.post(DOC_LIST_URL, this.payload, {
                adapter: adapter
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function mockAxiosAuthenticationError(_x2) {
        return _mockAxiosAuthenticationError.apply(this, arguments);
      }
      return mockAxiosAuthenticationError;
    }()
  }]);
  return DocListRequest;
}(DriveRequest);
var mapOrderBy2SortType = (_mapOrderBy2SortType = {}, _defineProperty(_mapOrderBy2SortType, OrderBy.AccessTime, SortType.RecentOpen), _defineProperty(_mapOrderBy2SortType, OrderBy.ModifyTime, SortType.RecentUpdate), _defineProperty(_mapOrderBy2SortType, OrderBy.Name, SortType.SortByName), _mapOrderBy2SortType);
var mapSource2SourceType = (_mapSource2SourceType = {}, _defineProperty(_mapSource2SourceType, SpecialSource.Mine, SourceType.Me), _defineProperty(_mapSource2SourceType, SpecialSource.Others, SourceType.Others), _mapSource2SourceType);
//# sourceMappingURL=doc-list.js.map